import ApiAdmin from "./ApiAdmin";
import { connect } from "react-redux";
import { actions } from "./apiAdminActions";

export default connect(
  state => ({ apiAdmin: state.apiAdmin }),
  actions
)(ApiAdmin);
